<template>
  <div>
    <anamnesis
      :dataCrud2.sync="localDataCrud"
      v-bind="{
        ...schema,
        handleEventsCrud,
        handleEvents,
        save,
        clickRowInfo,
        remove,
        snackbar,
        overlay,
        overlayMessage,
        toggleOverlay,
        status,
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Anamnesis from '@/components/includes/Anamnesis';

export default {
  name: 'ANxAPxMedicalPage',
  components: { Anamnesis },

  data: () => ({
    overlay: false,
    overlayMessage: '',
    backProbMedicalId: null,
    localDataCrud: [],
  }),

  watch: {
    dataCrud: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.localDataCrud = JSON.parse(JSON.stringify(newValue));
        }
      }
    }
  },

  computed: {
    ...mapGetters('anamANxAPxMedical', [
      'schema',
      'catDiagnosticICD10',
      'catDiagnosticICD11',
      'catDiagnosticDSM5',
      'dataCrud',
      'isNewRecord',
      'status',
    ]),
    ...mapGetters('anamPermissions', ['hasPermission']),
    ...mapGetters('notifications', ['snackbar']),
  },

  mounted() {
    this.loadData();
  },

  methods: {
    ...mapActions('anamANxAPxMedical', [
      'fetchSchema',
      'fetchRecords',
      'createRecord',
      'updateRecord',
      'removeRecord',
    ]),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.fetchRecords();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    handleEvents(val) {
      this.val = val;

      if (typeof val === 'object' && val !== null) {
        let nameProp1 = Object.hasOwn(val, 'diagnostic_manual');

        if (nameProp1) {
          this.diagnosticManual();
        }
      }
    },

    clickRowInfo(clickItem) {
      this.backProbMedicalId = clickItem.back_prob_medical_id;
      this.clickItemDiag = clickItem;

      if (typeof clickItem === 'object' && clickItem !== null) {
        let nameProp4 = Object.hasOwn(clickItem, 'back_medical_diagnostic_manual');

        if (nameProp4) {
          this.initDiagManual();
        }
      }
    },

    initDiagManual() {
      let medicalDiagManualId;
      !this.clickItemDiag.back_medical_diagnostic_manual.diagnostic_manual_id
        ? (medicalDiagManualId = null)
        : (medicalDiagManualId =
            this.clickItemDiag.back_medical_diagnostic_manual.diagnostic_manual_id);

      if (medicalDiagManualId === 1) {
        this.schema.formCrud.back_medical_diagnostic.items = this.catDiagnosticICD10;
      } else if (medicalDiagManualId === 2) {
        this.schema.formCrud.back_medical_diagnostic.items = this.catDiagnosticICD11;
      }
    },

    diagnosticManual() {
      let val = this.val;
      let manualId = val.diagnostic_manual_id;

      if (manualId === 1) {
        this.schema.formCrud.back_medical_diagnostic.items = this.catDiagnosticICD10;
      } else if (manualId === 2) {
        this.schema.formCrud.back_medical_diagnostic.items = this.catDiagnosticICD11;
      }
    },

    async save() {
      try {
        const model = { dataCrud: this.localDataCrud };
        const action = this.isNewRecord ? 'createRecord' : 'updateRecord';
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        this.fetchRecords();
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    async remove() {
      if (!this.backProbMedicalId) {
        return this.showSnackbar('No hay un registro seleccionado.', 'warning');
      }

      try {
        await this.removeRecord({ id: this.backProbMedicalId });
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackOkRemoved || 'Eliminado correctamente.'),
          'success'
        );      } catch (error) {
        console.error('Error al eliminar:', error);
        this.showSnackbar(this.sanitizeText(this.schema.snackError), 'error');
      }

      this.fetchRecords();
    },

    handleEventsCrud() {},

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>
